export default __webpack_public_path__ + "static/media/gallery-4.75a29fb4.jpg";